// extracted by mini-css-extract-plugin
module.exports = {"root":"SummaryReports_root__3ZOQ3"};